import { useQuery } from "@tanstack/react-query"
import { getClosedGiftCreditRequests } from "../../../../services/gift-credit"

const useGiftCreditHistoryRequests = () => {
  const query = useQuery({
    queryKey: ["GET_CREDIT_HISTORY_REQUESTS"],
    queryFn: async () => {
      const { data } = await getClosedGiftCreditRequests()

      return data?.value
    },
    gcTime: 0
  })

  return query
}

export default useGiftCreditHistoryRequests
